<template>
  <v-card class="ma-0" width="100%" style="height: auto" elevation="2">
    <v-app-bar flat class="my-0 mb-6 py-1 px-2" dense height="30">
      <v-toolbar-title class="mt-4 me-4">{{
        titleProp ? $t(titleProp) : $t($route.name, { name: $store.state.studentLabel })
      }}</v-toolbar-title>
      <div v-if="!isMobile && !isTablet && !mobileShow" style="width: 230px">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile && !mobileShow"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("remove") }}
        </p>
        <v-icon> mdi-trash-can-outline </v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important; padding: 0 !important"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon> mdi-dots-vertical </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item link @click="openUploadDialog">
            <v-list-item-icon>
              <v-icon>mdi-database-import-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('importData')" />
          </v-list-item>
          <log
            v-if="
              $store.state.permissions && $store.state.permissions.includes('logList')
            "
            ref="logRef"
            :type-prop="typeForm"
            :listProp="true"
            mode-prop="button"
          />
          <v-list-item v-if="isMobile || isTablet || mobileShow" link @click="getItems">
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet || mobileShow"
            link
            @getAllRows="getAllRows"
          >
            <export-excel
              ref="refExcel"
              :data="excelItems"
              worksheet="abriron.com"
              name="data-ai.xls"
              type="xls"
              class="float-left d-flex"
              :title="$store.state.abrName"
              :total-prop="pageCount"
              :page-prop="excelPage"
              @getAllRows="getAllRows"
            >
              <v-list-item-icon>
                <v-icon>mdi-file-excel-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('excel')" />
            </export-excel>
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet || mobileShow"
            link
            @click="printDialog = true"
          >
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet || mobileShow"
            link
            @click="
              $router.push({
                name: 'customer',
                params: {
                  personnelStatus: personnel,
                  tabName: personnel === 'active' ? $t('new-user') : $t('newCustomer'),
                },
              })
            "
          >
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              v-text="$t(personnel == 'active' ? $t('new-user') : $t('newCustomer'))"
            />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet && !mobileShow"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important; padding: 0 !important"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon> mdi-refresh </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile && !isTablet && !mobileShow"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn outlined class="mt-4 ms-2" color="grey darken-2 " height="32">
          <p class="font-weight-thin mb-0 me-2">
            {{ $t("excel") }}
          </p>
          <v-icon> mdi-file-excel-outline </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("filter") }}
        </p>
        <v-icon> mdi-filter-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet && !mobileShow"
        outlined
        @click="printDialog = true"
        class="mt-4 ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("print") }}
        </p>
        <v-icon> mdi-printer-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet && !mobileShow"
        outlined
        @click="
          $router.push({
            name: 'customer',
            params: {
              personnelStatus: personnel,
              tabName: personnel === 'active' ? $t('new-user') : $t('newCustomer'),
            },
          })
        "
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t(personnel == "active" ? $t("new-user") : $t("newCustomer")) }}
        </p>
        <v-icon> mdi-plus </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row v-if="isMobile || isTablet" class="mx-0">
      <v-col class="mb-4 px-2" cols="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-row class="mx-0"> </v-row>
    <v-col
      cols="12"
      class="px-2"
      :class="{ 'mt-6': !isMobile && !isTablet, 'mt-0': isMobile || isTablet }"
    >
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="isMobile || isTablet || mobileShow ? 323 : tableHeight"
        fixed-header
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :page.sync="page"
        :hide-default-header="isMobile || mobileShow"
        multi-sort
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3; border-radius: 6px"
        :footer-props="{
          showFirstLastPage: !mobileShow ? true : false,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus',
        }"
      >
        <template v-if="isMobile || mobileShow" v-slot:item="{ item, index }">
          <tr :class="{ 'mobile-show': mobileShow }">
            <td class="px-0">
              <v-list-item
                class="data-table-list-items mobile-td-list-border-primary"
                dense
              >
                <v-list-item-icon>
                  <div class="d-flex">
                    <p class="mt-1">
                      {{ +index + +1 }}
                    </p>
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn color="primary" v-bind="attrs" icon v-on="on">
                          <v-icon medium> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item link @click="edit(item)">
                          <v-list-item-icon>
                            <v-icon class="mt-2"> mdi-clipboard-edit </v-icon>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  icon
                                  small
                                  v-on="on"
                                  @click.stop.prevent="newTab('customerEdit', item)"
                                >
                                  <v-icon small color="primary">
                                    mdi-content-duplicate
                                  </v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("newTab") }}</span>
                            </v-tooltip>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item
                          v-if="$route.name == 'academyStudentList'"
                          link
                          @click="events(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-school-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('academyEventList')" />
                        </v-list-item>
                        <v-list-item
                          v-if="$route.name == 'academyTeacherList'"
                          link
                          @click="teacherCostList(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-school-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            v-text="$t('academyTeacherSessionCostList')"
                          />
                        </v-list-item>
                        <v-list-item link @click="turnover(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-recycle-variant</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('turnover')" />
                        </v-list-item>
                        <v-list-item link @click="remainAccountSms(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-message-text-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remainAccountSMS')" />
                        </v-list-item>
                        <v-list-item link @click="payment(item, 'pay')">
                          <v-list-item-icon>
                            <v-icon>mdi-credit-card-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('payCash')" />
                        </v-list-item>
                        <v-list-item link @click="payment(item, 'recieve')">
                          <v-list-item-icon>
                            <v-icon>mdi-cash</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('cashReceive')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="$baseURL + '/customer/edit/' + item.id"
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                        <v-list-item
                          v-show="removePermission('account')"
                          link
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ item.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    <a v-if="item.phone" :href="'tel:' + item.phone">
                      <v-btn class="mx-2 px-1" dark text small color="primary">
                        {{ item.phone }}
                        <v-icon dark small style="font-size: 12px"> mdi-phone </v-icon>
                      </v-btn>
                    </a>
                    <a v-if="item.mobile" :href="'tel:' + item.mobile">
                      <v-btn class="mx-2" dark text small color="primary">
                        {{ item.mobile }}
                        <v-icon dark small style="font-size: 12px"> mdi-phone </v-icon>
                      </v-btn>
                    </a>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="item.email" class="text-wrap">
                    {{ $t("email") }} : {{ item.email }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <div class="pt-1">
                      <v-chip
                        v-show="item.remain && parseFloat(item.remain.remain) < 0"
                        small
                        color="blue"
                        outlined
                      >
                        {{ $t("creditor") }}
                      </v-chip>
                      <v-chip
                        v-show="item.remain && item.remain.remain > 0"
                        small
                        color="red"
                        outlined
                      >
                        {{ $t("debtor") }}
                      </v-chip>
                      <v-chip
                        v-show="item.remain && item.remain.remain == null"
                        small
                        color="green"
                        outlined
                      >
                        {{ $t("clearing") }}
                      </v-chip>
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        :color="tag.color"
                        label
                        small
                        style="margin-left: 1px; margin-right: 1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ tag.text }}
                        </span>
                      </v-chip>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ms-1">
                  <v-btn dark text small color="primary" @click="turnover(item)">
                    {{ $numberFormat(item.remain ? item.remain.remain : 0) }}
                    {{ $store.state.currencySymbol }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.action="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" icon v-on="on">
                <v-icon medium> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item link @click="edit(item)">
                <v-list-item-icon>
                  <v-icon class="mt-2"> mdi-clipboard-edit </v-icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        icon
                        small
                        v-on="on"
                        @click.stop.prevent="newTab('customerEdit', item)"
                      >
                        <v-icon small color="primary"> mdi-content-duplicate </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("newTab") }}</span>
                  </v-tooltip>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-if="$route.name == 'academyStudentList'"
                link
                @click="events(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-school-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('academyEventList')" />
              </v-list-item>
              <v-list-item
                v-if="$route.name == 'academyTeacherList'"
                link
                @click="teacherCostList(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-school-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('academyTeacherSessionCostList')" />
              </v-list-item>
              <v-list-item link @click="turnover(item)">
                <v-list-item-icon>
                  <v-icon>mdi-recycle-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('turnover')" />
              </v-list-item>
              <v-list-item link @click="remainAccountSms(item)">
                <v-list-item-icon>
                  <v-icon>mdi-message-text-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remainAccountSMS')" />
              </v-list-item>
              <v-list-item link @click="payment(item, 'pay')">
                <v-list-item-icon>
                  <v-icon>mdi-credit-card-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('payCash')" />
              </v-list-item>
              <v-list-item v-if="personnel" link @click="openCardDialog(item)">
                <v-list-item-icon>
                  <v-icon>mdi-account-hard-hat-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('operationUser')" />
              </v-list-item>
              <v-list-item link @click="payment(item, 'recieve')">
                <v-list-item-icon>
                  <v-icon>mdi-cash</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('cashReceive')" />
              </v-list-item>
              <v-list-item link @click="openTaskDialog(item)">
                <v-list-item-icon>
                  <v-icon>mdi-notebook-plus-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ $t("new-task") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item link @click="openTaskDialogList(item)">
                <v-list-item-icon>
                  <v-badge
                    color="error"
                    overlap
                    :content="item.taskCount"
                    :value="item.taskCount"
                  >
                    <v-icon>mdi-format-list-bulleted-square</v-icon>
                  </v-badge>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ $t("tasks") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-clipboard:copy="$baseURL + '/customer/edit/' + item.id" link>
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                v-show="removePermission('account')"
                link
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.last_status.status_id="{ item }">
          <v-chip
            v-if="item.last_status && item.last_status.status"
            :color="item.last_status.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1 mb-1"
          >
            <span class="px-2 white--text">
              {{ item.last_status.status.name }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.row="{ item }">
          <v-card-text class="pa-0 text-caption text-disable">
            {{ parseInt(items.indexOf(item)) + parseInt(from) }}
          </v-card-text>
        </template>
        <template v-slot:item.firstname="{ item }">
          <v-container class="d-flex align-center gap-3 pa-0 ma-0" style="width: auto">
            <img :src="item?.avatar?.link || require('@/assets/Avatar.png')" />
            <v-container class="pa-0 ma-0" style="width: auto">
              <v-card-text class="d-flex align-center gap-1 pa-0">
                <span class="text-caption text-disable secondary--text"
                  >#{{ item.id }}</span
                >
                <a @click="edit(item)" class="text-body-2">
                  {{ item.firstname }} {{ item.lastname ? item.lastname : "" }}
                  {{ item.code ? "(" + item.code + ")" : "" }}
                </a>
              </v-card-text>
              <v-card-text class="pa-0 text-caption text-disable secondary--text">{{
                item.category ? item.category.name : "بدون دسته بندی"
              }}</v-card-text>
            </v-container>
          </v-container>
        </template>
        <template v-slot:item.national_code="{ item }">
          <v-card-text v-if="item.national_code" class="pa-0 text-caption">{{
            item.national_code
          }}</v-card-text>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">{{
            $t("haveNot")
          }}</v-card-text>
        </template>
        <template v-slot:item.remain="{ item }">
          <div>
            <a v-if="item.remain" @click="turnover(item)">
              <v-card-text class="pa-0 text-caption text-right">
                {{
                  item.remain
                    ? $numberFormat(item.remain.remain) + $store.state.currency.name
                    : 0
                }}
              </v-card-text>
            </a>
          </div>
          <v-card-text
            v-show="item.remain && parseFloat(item.remain.remain) < 0"
            class="pa-0 text-caption text-right"
            style="color: green"
          >
            {{ $t("creditor") }}
          </v-card-text>
          <v-card-text
            v-show="item.remain && item.remain.remain > 0"
            class="pa-0 text-caption text-right"
            style="color: red"
          >
            {{ $t("debtor") }}
          </v-card-text>
          <v-card-text
            v-show="item.remain && item.remain.remain == null"
            class="pa-0 text-caption text-right"
            style="color: green"
          >
            {{ $t("clearing") }}
          </v-card-text>
        </template>
        <template v-slot:item.connection_info="{ item }">
          <v-card-text
            v-if="item.mobile == null && item.phone == null && item.email == null"
            class="pa-0 text-caption text-disable secondary--text"
          >
            {{ $t("haveNot") }}
          </v-card-text>
          <div>
            <a
              v-if="item.mobile != null"
              :href="'tel:' + item.mobile"
              style="cursor: pointer"
              v-clipboard:copy="item.mobile"
              @click="copied"
            >
              <v-icon size="11" color="primary">mdi-phone</v-icon>
              {{ item.mobile }}
            </a>
          </div>
          <div>
            <a
              v-if="item.phone != null"
              :href="'tel:' + item.phone"
              style="cursor: pointer"
              v-clipboard:copy="item.phone"
              @click="copied"
            >
              <v-icon size="11" color="primary">mdi-phone-classic</v-icon>
              {{ item.phone }}
            </a>
          </div>
          <div>
            <a
              v-if="item.email != null"
              :href="'mailto:' + item.email"
              style="cursor: pointer"
              v-clipboard:copy="item.email"
              @click="copied"
            >
              <v-icon size="11" color="primary">mdi-email</v-icon>
              {{ item.email }}
            </a>
          </div>
        </template>
        <template v-slot:item.address="{ item }">
          <v-card-text v-if="item.address != null" class="pa-0 text-caption">
            {{ item.address }}
          </v-card-text>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">
            {{ $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.meta.branch.name="{ item }">
          <v-card-text v-if="item.meta && item.meta.branch" class="pa-0 text-caption">
            {{ item.meta.branch.name }}
          </v-card-text>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">
            {{ $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.content="{ item }">
          <div
            v-if="item.fin != null && item.fin.fin_code != null"
            class="d-flex align-center"
          >
            <v-card-text class="pa-0 text-caption">{{ $t("fin-id") }} : </v-card-text>
            <v-card-text
              v-if="item.fin != null && item.fin.fin_code != null"
              v-clipboard:copy="String(item.fin.fin_code || '')"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.fin.fin_code }}
            </v-card-text>
          </div>
          <div v-if="item.expire_date" class="pt-1">
            <v-chip
              label
              color="pink"
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="
                $store.state.userId === 'mWZdPLzdKg' ||
                $store.state.userId === 'LYqaQM7anj' ||
                $store.state.userId === 'z3YaOKgaxq' ||
                $store.state.userId === '4zbqlpZrap'
                  ? openExtensionDialog(item)
                  : null
              "
            >
              <span class="px-1 white--text">
                {{ $t("serviceExpireDate") }} : {{ item.expire_date }}
              </span>
            </v-chip>
          </div>
          <div v-if="item.plan_name" class="pt-1">
            <v-chip
              label
              color="primary"
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="
                $store.state.userId === 'mWZdPLzdKg' ||
                $store.state.userId === 'LYqaQM7anj' ||
                $store.state.userId === 'z3YaOKgaxq'
                  ? openExtensionDialog(item)
                  : null
              "
            >
              <span class="px-1 white--text">
                {{ $t("plan-name") }} : {{ item.plan_name }}
              </span>
            </v-chip>
          </div>
          <v-card-text
            v-if="
              item.integrator.length == 0 ||
              (item.integrator.length != 0 &&
                (!item.integrator.find((item) => item.key == 'woocommerceId') ||
                  (item.integrator.find((item) => item.key == 'woocommerceId') &&
                    item.integrator.find((item) => item.key == 'woocommerceId').value ==
                      null)) &&
                item.integrator.length != 0 &&
                (!item.integrator.find((item) => item.key == 'digikalaId') ||
                  (item.integrator.find((item) => item.key == 'digikalaId') &&
                    item.integrator.find((item) => item.key == 'digikalaId').value ==
                      null)) &&
                item.integrator.length != 0 &&
                (!item.integrator.find((item) => item.key == 'sazitoId') ||
                  (item.integrator.find((item) => item.key == 'sazitoId') &&
                    item.integrator.find((item) => item.key == 'sazitoId').value ==
                      null)) &&
                item.integrator.length != 0 &&
                (!item.integrator.find((item) => item.key == 'webziId') ||
                  (item.integrator.find((item) => item.key == 'webziId') &&
                    item.integrator.find((item) => item.key == 'webziId').value ==
                      null)) &&
                item.integrator.length != 0 &&
                (!item.integrator.find((item) => item.key == 'magnetId') ||
                  (item.integrator.find((item) => item.key == 'magnetId') &&
                    item.integrator.find((item) => item.key == 'magnetId').value ==
                      null)) &&
                item.content == null &&
                item.custom_fields.length == 0 &&
                item.expire_date == null &&
                item.fin_id == null)
            "
            class="pa-0 text-caption text-disable secondary--text"
          >
            {{ $t("haveNot") }}
          </v-card-text>
          <!--woocommerce id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="
              item.woocommerceItems.length > 0 && item.woocommerceItems[0].woocommerceId
            "
          >
            <img src="@/assets/woo.png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="
                item.woocommerceItems.length > 0 && item.woocommerceItems[0].woocommerceId
              "
              v-clipboard:copy="item.woocommerceItems[0].woocommerceId"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.woocommerceItems[0].woocommerceId }}
            </v-card-text>
          </v-container>
          <!--digikala id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="
              item.integrator.length > 0 &&
              item.integrator.find((item) => item.key == 'digikalaId') &&
              item.integrator.find((item) => item.key == 'digikalaId').value != null
            "
          >
            <img src="@/assets/digikala.png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="
                item.integrator.length > 0 &&
                item.integrator.find((item) => item.key == 'digikalaId') &&
                item.integrator.find((item) => item.key == 'digikalaId').value != null
              "
              v-clipboard:copy="
                item.integrator.find((item) => item.key == 'digikalaId').value
              "
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.find((item) => item.key == "digikalaId").value }}
            </v-card-text>
          </v-container>
          <!--sazito id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="
              item.integrator.length > 0 &&
              item.integrator.find((item) => item.key == 'sazitoId') &&
              item.integrator.find((item) => item.key == 'sazitoId').value != null
            "
          >
            <img src="@/assets/sazito(1).png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="
                item.integrator.length > 0 &&
                item.integrator.find((item) => item.key == 'sazitoId') &&
                item.integrator.find((item) => item.key == 'sazitoId').value != null
              "
              v-clipboard:copy="
                item.integrator.find((item) => item.key == 'sazitoId').value
              "
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.find((item) => item.key == "sazitoId").value }}
            </v-card-text>
          </v-container>
          <!--magnet id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="
              item.integrator.length > 0 &&
              item.integrator.find((item) => item.key == 'magnetId') &&
              item.integrator.find((item) => item.key == 'magnetId').value != null
            "
          >
            <img
              src="@/assets/integrators/logo-magnet.png"
              style="width: 20px; border-radius: 0"
            />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="
                item.integrator.length > 0 &&
                item.integrator.find((item) => item.key == 'magnetId') &&
                item.integrator.find((item) => item.key == 'magnetId').value != null
              "
              v-clipboard:copy="
                item.integrator.find((item) => item.key == 'magnetId').value
              "
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.find((item) => item.key == "magnetId").value }}
            </v-card-text>
          </v-container>
          <!--webzi id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="
              item.integrator.length > 0 &&
              item.integrator.find((item) => item.key == 'webziId') &&
              item.integrator.find((item) => item.key == 'webziId').value != null
            "
          >
            <img src="@/assets/webzi.png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="
                item.integrator.length > 0 &&
                item.integrator.find((item) => item.key == 'webziId') &&
                item.integrator.find((item) => item.key == 'webziId').value != null
              "
              v-clipboard:copy="
                item.integrator.find((item) => item.key == 'webziId').value
              "
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.find((item) => item.key == "webziId").value }}
            </v-card-text>
          </v-container>
          <!--custom filds-->
          <div v-if="item.custom_fields" class="pt-1">
            <v-chip
              v-for="(field, index) in item.custom_fields"
              :key="index"
              label
              color="primary"
              pa-0
              text-caption
              text-disable
              secondary--text
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text"> {{ field.key }} : {{ field.value }} </span>
            </v-chip>
          </div>
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{
              item.content
                ? item.content.substr(0, item.deleted_at ? item.content.length : 20)
                : ""
            }}
            {{
              !item.deleted_at && item.content && item.content.length > 20 ? "..." : ""
            }}
          </v-card-text>
        </template>
        <template v-slot:item.club_credit="{ item }">
          <v-card-text class="pa-0 text-body-2">
            {{ resolveClubCredit(item) }}
          </v-card-text>
        </template>
        <template v-slot:item.tags="{ item }">
          <v-container
            v-if="item.tags.length > 0"
            class="pa-0 d-flex gap-1"
            style="flex-wrap: wrap; max-width: 165px !important; min-width: 120px"
          >
            <v-chip
              v-for="(tag, index) in item.tags"
              :key="index"
              @click="edit(item)"
              label
              small
              class="px-1 mb-1"
              style="
                background: transparent;
                border: 1px solid #959494;
                border-radius: 10px !important;
              "
            >
              <span class="px-1">
                {{ tag.text }}
              </span>
            </v-chip>
          </v-container>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">{{
            $t("haveNot")
          }}</v-card-text>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                <v-card-text class="pa-0 text-caption">
                  {{ item.user.firstname }} {{ item.user.lastname }}
                </v-card-text>
              </div>
              <v-card-text
                v-else
                class="pa-0 text-caption text-disable secondary--text"
                >{{ $t("haveNot") }}</v-card-text
              >
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <!-- <template v-slot:item.attraction_method_id="{ item }">
          {{ (item.attraction_method ? item.attraction_method.name : '{{ $t('haveNot') }}') }}
        </template>
        <template v-slot:item.task-relation="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                color="primary"
                x-small
                class="mx-1"
                v-on="on"
                @click="openTaskDialog(item)"
              >
                {{ $t('new-task') }}
                <v-icon
                  small
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('new-task') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-badge
                color="error"
                overlap
                :content="item.taskCount"
                :value="item.taskCount"
              >
                <v-btn
                  v-if="item.taskCount > 0"
                  v-bind="attrs"
                  color="cyan"
                  x-small
                  v-on="on"
                  @click="openTaskDialogList(item)"
                >
                  {{ $t('tasks') }}
                  <v-icon small>
                    mdi-format-list-bulleted-square
                  </v-icon>
                </v-btn>
              </v-badge>
            </template>
            <span>{{ $t('tasks') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            v-if="item.status === 'active'"
            small
            color="blue"
            outlined
          >
            {{ $t('active') }}
          </v-chip>
          <v-chip
            v-if="item.lead === 'active'"
            small
            color="orange"
            class="mx-1"
            outlined
          >
            {{ $t('lead') }}
          </v-chip>
        </template>
        <template v-slot:item.row="{ item }">
          {{ parseInt(items.indexOf(item))+ parseInt(from) }}
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.rank="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                v-if="item.rank"
                class="mx-1"
                color="amber"
                text-color="brown"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  left
                  size="15"
                >
                  mdi-language-ruby
                </v-icon>
                {{ item.rank }}
              </v-chip>
              <v-card-text v-else class="pa-0 text-caption text-disable" >{{ $t('haveNot') }}</v-card-text>
            </template>
            <span>{{ $t('point') }}</span>
          </v-tooltip>
        </template> -->
        <template v-slot:body.append>
          <tr :class="{ 'v-data-table__mobile-table-row': isMobile || mobileShow }">
            <td
              :colspan="`${isMobile || mobileShow ? 6 : Number(showHeaders.length) - 6}`"
              :class="{ 'v-data-table__mobile-row': isMobile || mobileShow }"
            >
              <strong>{{ $t("sumRemain") }}</strong>
            </td>
            <td
              :colspan="`${isMobile || mobileShow ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile || mobileShow }"
            >
              <v-chip v-if="isMobile" color="primary" label small class="px-1 mb-1">
                <span class="px-1 white--text">
                  {{ $numberFormat(totals.amount) }}
                  {{ $store.state.currency ? $store.state.currency.symbol : "" }}
                </span>
              </v-chip>
              <div v-if="!isMobile">
                {{ $numberFormat(totals.amount) }}
                {{ $store.state.currency ? $store.state.currency.symbol : "" }}
              </div>
            </td>
            <td
              v-if="!isMobile"
              :colspan="`${isMobile || mobileShow ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile || mobileShow }"
            />
            <td
              v-if="!isMobile"
              :colspan="`${isMobile || mobileShow ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile || mobileShow }"
            />
          </tr>
        </template>
        <template v-slot:footer.prepend>
          <v-col v-show="!isMobile" cols="1" class="pa-0" style="margin-top: -10px">
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <v-dialog
      v-model="cardDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="cardDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2" />
        </v-col>
        <v-row class="ma-0">
          <card :account-prop="taskItem" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :turnover-prop="totals"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="filter = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("filter") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col md="2">
            <v-checkbox
              v-model="lead"
              class="mt-0"
              :label="$t('lead')"
              value="active"
              style="height: 20px"
            />
          </v-col>
          <v-col md="2">
            <v-checkbox
              v-model="status"
              class="mt-0"
              :label="$t('active')"
              value="active"
              style="height: 20px"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="financialStatus"
              :label="$t('financial-status')"
              :items="financialStatusItems"
              height="32"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="category"
              :title="$t('category')"
              type="accountCategory"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="attractionMethod"
              :title="$t('attractionMethod')"
              type="attractionMethod"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="registerar"
              :title="$t('registerar')"
              type="partners"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <tag v-model="tag" />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2" small>
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip v-if="index === 1" small>
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t("other") }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
        </v-row>
        <v-row v-if="!isMobile && customFieldsPermission" class="mx-0">
          <custom-field
            v-model="customFields"
            :value="customFields"
            type-prop="accountCustomFields"
            :multiple="true"
            class="px-4"
          />
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn class="mx-0" color="primary" @click="getItems">
                {{ $t("filter") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            ref="refTask"
            task-type="account"
            :ref-item="taskItem"
            ref-type="account"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialogList"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialogList = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("tasks") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task-list ref="refTaskList" type="account" :ref-id="refId" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="accountDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn icon color="grey darken-2" @click="accountDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("new-account") }}
          </p>
        </v-col>
        <v-card-text class="pa-0">
          <div class="overflow-y-auto ma-2 mt-0" style="height: 350px">
            <account @close="accountDialog = false" />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
    <v-dialog
      v-model="uploadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="customer"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="extensionDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="extensionDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <template>
            <v-text-field
              id="fromId"
              v-model="expireDate"
              :label="$t('expireDate')"
              outlined
              dense
              clearable
            />

            <date-picker
              v-model="expireDate"
              element="fromId"
              :locale="$store.state.date_locale"
              :format="$store.state.date_format"
              auto-submit
              :color="
                this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light']
                  .primary
              "
            />
          </template>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col class="px-0" cols="6">
              <v-btn color="primary" @click="setExtension">
                {{ $t("submit") }}
              </v-btn>
            </v-col>
            <v-col class="px-0" cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="extensionDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import Task from "../task/task";
import TaskList from "../task/list";
import Account from "./customer";
import Upload from "../../components/general/upload/upload";
import General from "../../../../Mixins/general";
import Print from "../../components/general/Print/Index";
import customField from "../../components/general/customFields/index.vue";
import card from "./card.vue";
export default {
  name: "CustomerList",
  components: {
    Tag: () => import("../../components/general/Tag/tag"),
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    card,
    Task,
    // pdfPrint,
    TaskList,
    customField,
    Upload,
    Account,
  },
  mixins: [General],
  props: [
    "input",
    "type",
    "data",
    "integratorTypeProp",
    "financialStatusProp",
    "mobileShow",
    "titleProp",
  ],
  data: () => ({
    pageCount: 1,
    page: 1,
    excelItems: [],
    printHeaders: [],
    selected: [],
    extensionDialog: false,
    extensionItem: null,
    customFields: null,
    cardDialog: false,
    expireDate: null,
    category: null,
    integratorType: null,
    rangeDate: null,
    registerar: null,
    attractionMethod: null,
    customerStatusItems: null,
    financialStatusItems: null,
    printDialog: false,
    uploadDialog: false,
    accountDialog: false,
    deletDialog: false,
    filter: false,
    financialStatus: null,
    customerStatus: null,
    status: "active",
    taskindex: 0,
    lead: null,
    refId: null,
    taskItem: null,
    model: null,
    from: 1,
    taskDialog: null,
    taskDialogList: null,
    showSelect: true,
    tag: null,
    temp: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    deleteItem: null,
    headers: null,
    personnel: null,
    typeForm: "account",
    search: null,
    renderTable: null,
    selectedHeaders: [],
    hasDobarePermission: false,
    //   tableData: [
    //     { name: '<div style="color: blue;">John Doe</div>', age: 300000, country: '<button>USA</button>' },
    //     { name: '<strong>Jane Smith</strong>', age: 2500000, country: '<button>UK</button>' },
    //     { name: '<em>Kevin Brown</em>', age: 350000, country: '<button>Canada</button>' },
    //   ],
    //   columns: [
    //     {
    //       data: 'name',
    //       renderer: htmlRenderer, // استفاده از رندرکننده سفارشی برای نمایش HTML
    //     },
    //     {
    //       data: 'age',
    //       type: 'numeric',
    //     },
    //     {
    //       data: 'country',
    //       renderer: htmlRenderer, // استفاده از رندرکننده سفارشی برای نمایش HTML
    //     },
    //   ],
    //   hotSettings: {
    //     licenseKey: 'non-commercial-and-evaluation', // کلید لایسنس
    //     stretchH: 'all',
    //     autoWrapRow: true,
    //     height: 'auto',
    //     maxRows: 10,
    //     manualRowResize: true,
    //     manualColumnResize: true,
    //   },
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        if (app.type !== "sell") {
          if (s.value === "pre_invoice") {
          } else {
            if (s.align != "d-none") {
              return app.selectedHeaders.includes(s);
            }
          }
        } else {
          if (s.align != "d-none") {
            return app.selectedHeaders.includes(s);
          }
        }
      });
    },
    totals: function () {
      var app = this;
      const totals = this.items.reduce(
        (acc, d) => {
          acc.amount += parseFloat(d.remain ? d.remain.remain : 0);
          return acc;
        },
        {
          amount: 0,
        }
      );
      app.renderTable = true;
      return totals;
    },
  },
  watch: {
    taskDialogList(val) {
      if (!val) {
        this.getItems();
      }
    },
    taskDialog(val) {
      if (!val) {
        this.getItems();
      }
    },
    data(val) {
      this.model = val.description;
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.page = 1;
      app.loading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options?.sortBy?.map(function (value) {
          const index = app.headers?.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        app.page = app.options?.page;
        app.itemsPerPage = app.options?.itemsPerPage;
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers?.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
  },
  activated() {
    // this.getItems()
  },
  beforeMount() {
    this.hasDobarePermission = JSON.parse(localStorage.getItem("hasDobarePermission"));

    if (this.$route.name === "leadList") {
      this.lead = "active";
    }
    if (this.$route.name === "usersList") {
      this.personnel = "active";
    }
    if (this.$route.name === "academyStudentList") {
      this.integratorType = "student";
    }
    if (this.$route.name === "academyTeacherList") {
      this.integratorType = "teacher";
    }
    if (this.$route.params.financialStatus) {
      this.financialStatus = this.$route.params.financialStatus;
    }
    this.customerStatusItems = [
      {
        value: "lead",
        text: this.$t("lead"),
      },
      {
        value: "on",
        text: this.$t("active"),
      },
    ];
    this.financialStatusItems = [
      {
        value: ">",
        text: this.$t("debtor"),
      },
      {
        value: "<",
        text: this.$t("creditor"),
      },
      {
        value: "=",
        text: this.$t("clearing"),
      },
    ];

    this.printHeaders = [
      {
        text: this.$t("name"),
        value: "name",
      },
      {
        text: this.$t("category"),
        value: "category.name",
        width: 15,
      },
      {
        text: this.$t("phone"),
        value: "phone",
        width: 10,
      },
      {
        text: this.$t("mobile"),
        value: "mobile",
        width: 10,
      },
      {
        text: this.$t("remain"),
        value: "remain.remain",
        type: "number",
        width: 15,
        sum: true,
      },
    ];
  },
  mounted() {
    this.headers = [
      {
        text: this.$t("action"),
        align: "start",
        sortable: false,
        value: "action",
        width: 20,
      },
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        table: "users.id",

        width: 20,
      },
      /*   {
          text: this.$t('id'),
          sortable: true,
          value: 'id',
          table: 'users.id',
        }, */
      {
        text: this.$t("name and category"),
        sortable: true,
        value: "firstname",
        table: "users.name",
        width: 300,
      },
      {
        text: this.$t("national-code"),
        sortable: true,
        value: "national_code",
        table: "users.national_code",
      },
      {
        text: this.$t("remain"),
        sortable: true,
        value: "remain",
        table: "doc_article.remain",
      },
      /*   {
          text: this.$t('task-relation'),
          sortable: false,
          value: 'task-relation',
        }, */
      /*  {
          text: this.$t('customer-status'),
          sortable: false,
          value: 'status',
        }, */
      /*   {
          text: this.$t('attractionMethod'),
          sortable: false,
          value: 'attraction_method_id',
        }, */
      /*      {
          text: this.$t('category'),
          sortable: true,
          value: 'category.name',
          table: 'users_category.name',
        }, */
      {
        text: this.$t("connection-info"),
        sortable: false,
        value: "connection_info",
      },
      /*         {
          text: this.$t('mobile'),
          sortable: true,
          value: 'mobile',
          table: 'users.mobile',
        },
        {
          text: this.$t('email'),
          sortable: true,
          value: 'email',
          table: 'users.email',
        }, */
      {
        text: this.$t("address"),
        sortable: true,
        value: "address",
        table: "users.address",
      },
      {
        text: this.$t("other"),
        sortable: true,
        value: "content",
        table: "users.content",
      },
      {
        text: this.$t("club-credit"),
        sortable: true,
        value: "club_credit",
        align: !this.hasDobarePermission ? "d-none" : "center",
      },
      /* {
          text: this.$t('accountCode'),
          sortable: true,
          value: 'fin.fin_code',
          table: 'financial_detail_coding.code',
        }, */
      /*   {
          text: this.$t('financial-status'),
          sortable: false,
          value: 'state',
        }, */
      /*      {
          text: this.$t('point'),
          sortable: true,
          value: 'rank',
          table: 'users_rank.point',
        }, */
      {
        text: this.$t("tag"),
        sortable: false,
        value: "tags",
      },
      {
        text: this.$t("branch"),
        sortable: false,
        value: "meta.branch.name",
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
      },
      // {
      //   text: this.$t('time'),
      //   sortable: false,
      //   value: 'time',
      // },
    ];

    this.headersMap = this.headers;
    this.selectedHeaders = this.headers;
    if (this.input) {
      this.model = this.input;
    }
    if (this.financialStatusProp) {
      this.financialStatus = this.financialStatusProp;
    }
  },
  methods: {
    resolveClubCredit(item) {
      const dobare = item.customer_club_credit.find((obj) => obj.key == "customer_club_credit");
      if (dobare) {
        return this.$numberFormat(dobare.value) + " " + this.$store.state.currencySymbol;
      } else {
        return this.$t("haveNot");
      }
    },
    openExtensionDialog(item) {
      this.$router.push({
        name: "planAdministration",
        params: { abr: item.abr_id, name: item.name },
      });
    },
    setExtension() {
      var app = this;
      app.loading = true;
      app.extensionDialog = false;
      app.$axios
        .get(this.$endpoint + "customer", {
          params: {
            account: app.extensionItem,
            expireDate: app.expireDate,
          },
        })
        .then((res) => {
          res = res.data;
          app.getItems();
        })
        .catch((err) => {
          var error = err.response;
          if (error.status === 401) {
            this.$router.push({ name: "logout" });
          }
        })
        .finally(() => (app.loading = false));
    },
    openUploadDialog() {
      this.uploadDialog = true;
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openCardDialog(item) {
      this.taskItem = item;
      this.cardDialog = true;
    },
    openTaskDialog(item) {
      if (this.$refs.refTask) {
        this.$refs.refTask.clearForm();
      }
      this.taskItem = item;
      this.taskDialog = true;
    },
    openTaskDialogList(item) {
      if (this.$refs.refTaskList) {
        this.$refs.refTaskList.getItems();
      }
      this.refId = item.id;
      this.taskDialogList = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      /* if($store.state.permissions) */
      this.$router.push({ name: "customerEdit", params: { id: item.id } });
    },
    payment(item, type) {
      this.$router.push({ name: type, params: { accountProp: item } });
    },
    teacherCostList(item) {
      this.$router.push({
        name: "academyTeacherSessionCostList",
        params: { teacherProp: item },
      });
    },
    events(item) {
      this.$router.push({ name: "academyEventList", params: { studentIdProp: item.id } });
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.filter = false;
      app.$axios
        .get(this.$endpoint + "customer/show", {
          params: {
            search: app.search,
            registerar: app.registerar,
            rangeDate: app.rangeDate,
            category: app.category,
            attractionMethod: app.attractionMethod,
            status: app.status,
            personnel: app.personnel,
            lead: app.lead,
            customFields: app.customFields,
            branch: app.branch,
            page: app.allRows ? app.excelPage : app.options.page,
            type: app.type,
            sortBy: app.sortBy,
            integratorType: app.integratorType,
            options: app.options,
            tag: app.tag,
            customerStatus: app.customerStatus,
            remainStatus: app.financialStatus,
          },
        })
        .then((res) => {
          res = res.data;
          if (!app.allRows) {
            app.items = res.data;
            app.totalItems = res.total;
            app.last_page = res.last_page;
            app.pageCount = res.last_page;
            app.from = res.from;
            app.creatExcelData(res.data);
          } else {
            app.generateExcellForAllData(res.data, res.last_page);
          }
        })
        .catch((err) => {
          var error = err.response;
          if (error.status === 401) {
            this.$router.push({ name: "logout" });
          }
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "customer/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    removegroup() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value) {
        selected.push({ id: value.id });
      });
      app.$axios
        .delete(this.$endpoint + "customer/0", {
          params: { deleteItems: selected },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    print() {
      this.$htmlToPaper("print");
    },
    turnover(item) {
      this.$router.push({
        name: "turnoverDetail",
        params: {
          id: item.fin_id,
          accountProp: { fin_id: item.fin_id, name: item.name },
          tabName: item.name,
        },
      });
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        app.excelItems.push({
          id: d.id,
          name: String(d.name),
          category: d.category ? d.category.name : "",
          phone: d.phone ? String(d.phone) : "",
          remain: d.remain ? d.remain.remain : "",
          mobile: d.mobile ? d.mobile : "",
          national_code: d.national_code ? d.national_code : "",
          email: d.email ? d.email : "",
          address: d.address ? d.address : "",
          content: d.content ? d.content : "",
          birth_date: d.birth_date ? d.birth_date : "",
          country: d.country ? d.country.name : "",
          state: d.state ? d.state.name : "",
          city: d.city ? d.city.name : "",
          finantial_code: d.fin && d.fin.fin_code ? d.fin.fin_code : "",
          financial_code: d.financial_code ? d.financial_code : "",
        });
      });
    },
  },
};
</script>

<style scoped>
.v-badge__badge {
  height: 16px !important;
  min-width: 16px !important;
  padding: 4px 6px !important;
}
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  height: initial;
  min-height: 32px !important;
}
::v-deep .v-data-table table tbody tr {
  /* height: 72px; */
}
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .v-data-table table tbody tr td:nth-child(8) {
  white-space: unset;
  min-width: 185px;
}
.v-card__text {
  width: auto;
}
img {
  width: 32px;
  border-radius: 4px;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
/* ::v-deep .v-data-table {
    border: 1px solid #999999;
    border-radius: 6px !important;
    padding: 4px;
}
::v-deep .v-data-table__wrapper {
    margin-bottom: 5%;
}
::v-deep .v-data-table-header {
    background-color: #D9D9D9;
}
::v-deep .v-data-table-header tr th:first-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
::v-deep .v-data-table-header tr th:last-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
::v-deep .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
    font-size: 8pt !important;
    color: #000;
}
    ::v-deep .theme--light.v-data-table.v-data-table--fixed-header thead th {
  background: #D9D9D9 !important;
}*/
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd),
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even) {
  /* background-color: transparent !important; */
  height: 60px;
}
/* ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
::v-deep .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  height: 40px;
} */
.v-card__text {
  width: auto;
}
.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
  width: auto;
}
::v-deep .v-input--selection-controls__ripple {
  width: auto;
  height: auto;
  margin: 0;
}
::v-deep .v-btn--icon.v-size--default {
  height: auto;
  width: auto;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  height: 48px;
}
@media (max-width: 863px) {
  ::v-deep .v-data-table table tbody tr,
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(odd),
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(even) {
    height: auto;
  }
}
</style>
